<template>
    <div class="tjfx-htfk app-container">
        <el-row type="flex" align="middle">
            <div style="margin-right: 20px">
                <span style="font-size: var(--portalFontSize14)">统计周期：</span>
                <el-date-picker v-model="search.date" type="monthrange" :clearable="false" value-format="yyyy-MM" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" />
            </div>
            <statistics-search @statisticsClick="statistics" />
        </el-row>
        <div class="statistics_title">投标中标情况</div>
        <div class="echart">
            <EchartColumnar
                v-if="showEchar"
                tooltip-type="shadow"
                :tooltip-format="echartOption.tooltipFormatter"
                bottom="30"
                left="80"
                :x-type-name="xTypeName"
                :x-chart-num="1"
                bar-max-width="50%"
                :x-data="xData"
                :y-data="yData"
                :y-unit="{
                    name: '中标率',
                    align: 'end',
                    size: '12',
                    position: 'left',
                    labelFormatter: echartOption.yAxisFormatter
                }"
                :color="['#48c9b3']"
                :chart-type="[{ type: 'line' }]"
                :is-legend="true"
                :legend-align="{ location: 'bottom', align: '0' }"
                legend-icon="roundRect"
            />
        </div>
        <div>
            <data-table ref="dataTable" :table-column="tableColumn" :list-data="tableListData" />
        </div>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            // 查询条件
            search: {
                date: [],
                type: 0
            },
            // echart参数
            echartOption: {
                yAxisFormatter: (val) => {
                    let str = val + '%'
                    return str
                },
                tooltipFormatter: (val) => {
                    let str = ''
                    if (val && val.length) {
                        str = val[0].name
                        val.forEach((v) => {
                            str += `<br>${v.marker}${v.seriesName}：${v.value + '%'}`
                        })
                    }
                    return str
                }
            },
            xData: [],
            yData: [],
            xTypeName: [],
            // 表格参数
            tableColumn: [],
            // 表格数据
            tableListData: [],
            showEchar: false
        }
    },
    created() {
        this.$options.components['dataTable'] = this.$loadComponent('@/wapp/tbgl/tjfx/components/ListTable')
        this.$options.components['StatisticsSearch'] = this.$loadComponent('@/wapp/common/components/CCStatisticsSearch')

        this.$bus.emit('showNavSearch', false)
        this.search.date = [moment().add(-1, 'Y').format('YYYY-MM'), moment().format('YYYY-MM')]
        this.getTableColumn()
    },
    mounted() {},
    beforeDestroy() {
        this.$bus.emit('showNavSearch', true)
    },
    methods: {
        getTableColumn() {
            const tableColumn = [
                {
                    prop: 'month',
                    title: '月份',
                    align: 'left',
                    width: ''
                },
                {
                    prop: 'tbCount',
                    title: '投标数',
                    align: 'center',
                    width: '110'
                },
                {
                    prop: 'zbCount',
                    title: '中标数',
                    align: 'center',
                    width: '110'
                },
                {
                    prop: 'htAmount',
                    title: '合同总金额（元）',
                    align: 'right',
                    width: '150'
                },
                {
                    prop: 'htCount',
                    title: '合同签订数',
                    align: 'center',
                    width: '110'
                },
                {
                    prop: 'zbTax',
                    title: '中标率',
                    align: 'center',
                    width: '110'
                }
            ]
            this.tableColumn = tableColumn
        },
        statistics() {
            this.getData()
        },
        getData() {
            const [startDateStr, endDateStr] = this.search.date || []
            const data = {
                startDateStr,
                endDateStr
            }
            this.$http({
                url: 'tbgl/tbxmlx/lineChartAndList',
                method: 'get',
                contentType: 'application/x-www-form-urlencoded',
                params: data
            }).then((res) => {
                if (res.code === 'success') {
                    this.tableListData = res.body.listdata
                    const props = res.body.vo.props
                    this.xData = props.xData[0]
                    this.yData = props.yData
                    this.xTypeName = props.xTypeName
                    this.showEchar = true
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.tjfx-htfk {
    .echart {
        height: 300px;
        // margin-top: 30px;
    }
    .label {
        line-height: 36px;
        font-size: var(--portalFontSize14);
        width: 84px;
        color: #606266;
        margin-left: 20px;
    }
    /deep/.el-date-editor .el-range-separator {
        width: 20px;
        padding: unset;
    }
}
</style>
